__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "shell-app";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e("vendors-node_modules_emotion_cache_dist_emotion-cache_browser_esm_js"), __webpack_require__.e("node_modules_emotion_react_dist_emotion-react_browser_esm_js-_31720")]).then(() => (() => (__webpack_require__("./node_modules/@emotion/react/dist/emotion-react.browser.esm.js"))))));
			register("@emotion/styled", "11.14.0", () => (Promise.all([__webpack_require__.e("webpack_sharing_consume_default_emotion_react_emotion_react"), __webpack_require__.e("node_modules_emotion_styled_dist_emotion-styled_browser_esm_js-_22810")]).then(() => (() => (__webpack_require__("./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js"))))));
			register("@mui/material", "5.17.1", () => (Promise.all([__webpack_require__.e("vendors-node_modules_emotion_cache_dist_emotion-cache_browser_esm_js"), __webpack_require__.e("vendors-node_modules_mui_material_index_js"), __webpack_require__.e("vendors-node_modules_mui_material_CssBaseline_CssBaseline_js-node_modules_mui_material_styles-ac3da0"), __webpack_require__.e("webpack_sharing_consume_default_emotion_react_emotion_react"), __webpack_require__.e("webpack_sharing_consume_default_emotion_styled_emotion_styled")]).then(() => (() => (__webpack_require__("./node_modules/@mui/material/index.js"))))));
			register("@mui/styles", "6.5.0", () => (Promise.all([__webpack_require__.e("vendors-node_modules_mui_styles_index_js"), __webpack_require__.e("node_modules_react-is_cjs_react-is_production_js-node_modules_react_jsx-runtime_js-node_modul-2b2af5")]).then(() => (() => (__webpack_require__("./node_modules/@mui/styles/index.js"))))));
			register("@uncola/auth-client", "1.0.0", () => (() => (__webpack_require__("../packages/auth-client/src/index.js"))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__("./node_modules/react-dom/index.js"))), 1);
			register("react-router-dom", "6.30.1", () => (() => (__webpack_require__("./node_modules/react-router-dom/dist/index.js"))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__("./node_modules/react/index.js"))), 1);
			initExternal("webpack/container/reference/notificationsApp");
			initExternal("webpack/container/reference/authApp");
			initExternal("webpack/container/reference/careerFeedApp");
			initExternal("webpack/container/reference/profileApp");
			initExternal("webpack/container/reference/reportsApp");
			initExternal("webpack/container/reference/adminApp");
			initExternal("webpack/container/reference/dashboardApp");
			initExternal("webpack/container/reference/jobAgentApp");
			initExternal("webpack/container/reference/interviewQuestionsApp");
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};